"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.prototype.render = function () {
        //return <div className="row">
        //    <div className="col-sm-3">
        //        <a href="https://www.floir.com" target="_blank" rel="noopener noreferrer"><img className="img-responsive center-block" src={require('../images/footer2.gif')} alt="MyFlorida Logo" /></a>
        //    </div>
        //    <div className="col-sm-5 text-center">
        //        Contact Us<br />
        //        Florida Department of Financial Services
        //    <br />
        //        200 East Gaines Street, Tallahassee, FL 32399 (850) 413-3140
        //</div>
        //</div>
        return React.createElement("div", { className: "OIRFooter" },
            React.createElement("div", { className: "col-sm-12" },
                React.createElement("div", { className: "footerLogo" },
                    React.createElement("a", { href: "http://floir.com" },
                        React.createElement("img", { src: require("../images/oir-symbol-white.png") }))),
                React.createElement("div", { className: "footerContact" },
                    React.createElement("h5", { style: { color: "#fff" } }, "OFFICE OF INSURANCE REGULATION"),
                    React.createElement("p", { style: { fontSize: "10pt" } },
                        "200 East Gaines Street",
                        React.createElement("br", null),
                        "Tallahassee, FL 32399",
                        React.createElement("br", null),
                        React.createElement("a", { href: "tel:8504133140", style: { color: "#fff" } }, "(850) 413-3140"))),
                React.createElement("div", { className: "footerContent" },
                    React.createElement("div", { style: { marginTop: "5px" } },
                        React.createElement("strong", null, "Insurance Commissioner")),
                    React.createElement("div", null, "Michael Yaworsky"),
                    React.createElement("br", null),
                    React.createElement("small", { className: "font-italic" }, "Copyright \u00A9 Florida Office of Insurance Regulation 2023"))));
    };
    return Footer;
}(React.PureComponent));
;
exports.default = Footer;
//# sourceMappingURL=Footer.js.map